/* eslint-disable no-unused-expressions */
/* eslint no-underscore-dangle: 0 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GPT from 'react-gpt/lib/Bling';
import { connect } from 'react-redux';
import get from 'lodash/get';
// import cloneDeep from 'lodash/cloneDeep';

import isNumber from 'lodash/isNumber';
import Cookies from 'js-cookie';
import union from 'lodash/union';
import { canUseDOM } from 'exenv';
import log from '../../../services/logger_service';
import prebidConf from '../../../config/prebidConf';

import adLoaded from '../../../redux/action_creators/ads_action_creator';

import getQueryParameterByName from '../../../utils/url_util';

let hasSetSafeFrameRefresh = false;
let adRefreshQueue = [];
// eslint-disable-next-line no-unused-vars
let prebidConfProcessed = null;

if (canUseDOM) {
  // Enable sync correlator value
  GPT.syncCorrelator();
}

/**
 *
 * @param {Array} keysArray a list of keys to clear from targetting
 */
function removeSlideshowAdKeyTargeting(keysArray) {
  const slots = window.parent.googletag.pubads().getSlots();
  // eslint-disable-next-line no-plusplus
  for (let i = slots.length; i--; ) {
    // eslint-disable-next-line no-plusplus
    for (let j = keysArray.length; j--; ) {
      slots[i].clearTargeting(keysArray[j]);
    }
  }
}

/**
 * Clears a list of key vals from targetting and refresh the
 * ad based on matching matching key val "slotid" and limit to flexibleportrait unit
 *
 * @param {Array} keysArray
 * @param {String} slotId
 */
function refreshSafeFrameSlot(keysArray, slotId) {
  const { googletag } = window;
  if (!googletag) {
    return;
  }

  if (
    slotId.indexOf('flexibleportrait') === -1 &&
    slotId.indexOf('flexiblehalfpage') === -1
  ) {
    return;
  }

  const slots = googletag.pubads().getSlots();
  // eslint-disable-next-line no-plusplus
  for (let i = slots.length; i--; ) {
    const targetSlotID = get(slots[i].getTargeting('slotid'), '[0]');
    if (targetSlotID && targetSlotID === slotId) {
      // eslint-disable-next-line no-plusplus
      for (let j = keysArray.length; j--; ) {
        slots[i].clearTargeting(keysArray[j]);
      }
      googletag.pubads().refresh([slots[i]], { changeCorrelator: false });
    }
  }
}

/**
 * Refreshes the queue of ads stored up from when the user is not active on the page
 */
function refreshAdQueue() {
  if (adRefreshQueue.length) {
    adRefreshQueue.forEach(slotId => {
      refreshSafeFrameSlot(
        [
          'prebid_trigger',
          'hb_bidder',
          'hb_adid',
          'hb_pb',
          'hb_size',
          'hb_deal'
        ],
        slotId
      );
    });
    adRefreshQueue = [];
  }
}

/**
 * An Ad Component using Google Publisher Tags wrapped on top of react-gpt from NFL
 * https://github.com/nfl/react-gpt
 * https://developers.google.com/doubleclick-gpt/
 *
 * DEBUG MODE: Append ?debug to url to enable console logging of ad events
 * EXAMPLE USAGE:
 * const combinedAdModel = { ...AdConfig, ...AdContext };
 *     <Ad
 *      {...combinedAdModel}
 *       name="flexibleleaderboard"
 *     />
 * where combinedAdModel is an object merged from ad_context.json and config.json.
 * note: ad_context.json is a stub, in the real world,
 * that data would come from the page context model
 *
 */
class Ad extends Component {
  constructor() {
    super();
    this.addSlideShowAdRefreshListener = this.addSlideShowAdRefreshListener.bind(
      this
    );
    // this.state = {
    //   randNum: Math.floor(Math.random() * 10)
    // };
    this.callNativeAlwaysOn = this.callNativeAlwaysOn.bind(this);
    this.bomboraTargeting = this.bomboraTargeting.bind(this);

    this.refreshFunctionCalled = false;

    if (canUseDOM) {
      // set Bombora targeting values
      this.bomboraTargeting();
    }
  }

  // componentDidMount() {
  //   window.pbjs.aliasBidder("appnexus", "pangaea");
  // }
  shouldComponentUpdate(nextProps) {
    const { adsLoaded } = nextProps;
    if (!adsLoaded) {
      return true;
    }
    return false;
  }

  componentWillUnmount() {
    if (this.props.canRefresh) {
      window.removeEventListener(
        'FC_REFRESH_EVENT',
        this.addSlideShowAdRefreshListener
      );
    }
  }

  setGDPR() {
    // for GDPR set this during first ad call of the page
    // This value will get reseted during each page transition
    //  console.log("GPT._adManager.googletag.pubads().setRequestNonPersonalizedAds(1) ", GPT._adManager.googletag.pubads().setRequestNonPersonalizedAds(1));
    // if (
    //   window &&
    //   !window.fc_ads.calledNonPersonalize &&
    //   // eslint-disable-next-line no-underscore-dangle
    //   GPT._adManager &&
    //   // eslint-disable-next-line no-underscore-dangle
    //   GPT._adManager.googletag &&
    //   // eslint-disable-next-line no-underscore-dangle
    //   GPT._adManager.googletag.pubads() &&
    //   // eslint-disable-next-line no-underscore-dangle
    //   GPT._adManager.googletag.pubads().setRequestNonPersonalizedAds
    // ) {
    //   // eslint-disable-next-line no-underscore-dangle
    //   // console.log('0-------------->GDPR')
    //   // GPT._adManager.googletag.pubads().setRequestNonPersonalizedAds(1);
    //   window.fc_ads.calledNonPersonalize = true;
    // }
  }

  bomboraTargeting() {
    const mlTopics = get(window, 'digitalData.page.pageInfo.mlTopic', []);
    const mlCategories = get(
      window,
      'digitalData.page.pageInfo.mlCategory',
      []
    );
    const mlMergedData = mlTopics.concat(mlCategories);
    if (mlMergedData.length > 0) {
      GPT.setTargeting('mlTopic', mlMergedData);
      // GPT.setTargeting("mlCategory", mlCategories);
    }
  }

  constructData() {
    const {
      baseConfig,
      definitions,
      model,
      name,
      region,
      slug,
      oop,
      pos,
      pageNum,
      noLazyLoad,
      readTime,
      ceros
    } = this.props;

    let { adzoneOverride } = this.props;
    const siteZone = get(baseConfig, 'siteZone', null);

    const defaultSizeMapping = [
      {
        slot: [],
        viewport: []
      }
    ];

    if (!siteZone) {
      log.error('No siteZone config object set');
      // Set a default for GPT lib, they need this value or else it will crash the app
      this.sizeMapping = defaultSizeMapping;
      return;
    }

    this.name = name;
    this.region = region;
    this.oop = oop;
    this.pos = pos === 'atf' ? 'atf' : 'btf'; // position defaults to below the fold
    this.ceros = ceros;

    // lazy load = atf, non-lazy load = btf
    this.pos = noLazyLoad ? 'btf' : 'atf';

    // Figure out adzone
    const companyID = get(baseConfig, 'companyID');
    const site = get(model, 'site') || 'fastcompany';
    const zone = get(model, 'adzone');

    // If querystring override is enabled then override the adzone
    const queryAdzoneOverride = getQueryParameterByName('adzone');

    if (queryAdzoneOverride) {
      adzoneOverride = queryAdzoneOverride;
    }

    this.constructAdZone(companyID, siteZone, zone, adzoneOverride, site, name);

    // Figure out size mapping
    this.sizeMapping = get(
      definitions[name],
      'sizeMapping',
      defaultSizeMapping
    );

    // Figure out key val mapping, returns a key val pair object
    this.constructKeyVals(model, pageNum, name, readTime);

    // Optionally display "advertisement" label
    this.adLabel =
      slug === false ? (
        ''
      ) : (
        <div className="ad-wrapper__ad-slug">advertisement</div>
      );

    if (noLazyLoad) {
      this.noLazyLoad = true;
    }
  }

  addSlideShowAdRefreshListener(event) {
    if (canUseDOM) {
      window.addEventListener('FC_REFRESH_EVENT', function eventListener(e) {
        try {
          if (event.slot.getAdUnitPath().indexOf(e.detail) !== -1) {
            window.removeEventListener('FC_REFRESH_EVENT', eventListener);
            removeSlideshowAdKeyTargeting([
              'prebid_trigger',
              'hb_bidder',
              'hb_adid',
              'hb_pb',
              'hb_size',
              'hb_deal'
            ]);
            GPT.refresh([event.slot]);
          }
        } catch (err) {
          log.error(err, 'unable to refresh ad in from 3 slides.');
        }
      });
    }
  }

  /**
   * Use anti-fraud detection to add a window listener from
   * ad unit's post message safe frame.
   * AntiFraud Detection: If the user hasn't moved for x amount of seconds,
   * ad unit will not refresh even if it passed the time needed to refresh.
   * Refresh Logic: Listens to an event from ad's safeframe,
   * if the event is heard, and user is not inactive, then refresh the ad unit.
   */
  attachSafeFrameRefreshEvent() {
    if (hasSetSafeFrameRefresh === false) {
      const d = document || window.document;
      d.onload = refreshAdQueue;
      d.onmousemove = refreshAdQueue;
      d.onmousedown = refreshAdQueue;
      d.ontouchstart = refreshAdQueue;
      d.onclick = refreshAdQueue;
      d.onscroll = refreshAdQueue;
      d.onkeypress = refreshAdQueue;

      window.addEventListener(
        'message',
        event => {
          const dataSource = get(event, 'data.source');
          const slotId = get(event, 'data.slotId');
          if (dataSource === 'fc_ad_refresh') {
            adRefreshQueue.push(slotId);
          }
        },
        false
      );
      hasSetSafeFrameRefresh = true;
    }
  }
  /**
   *
   * Converts a url into a unique hash value, ported over from admanager
   */
  constructCMSHash(url) {
    const cmsQueryValue = getQueryParameterByName('cms');

    if (cmsQueryValue) {
      return cmsQueryValue;
    }

    const key = url || document.location.href;
    let hash = 0;
    let i;
    let chr;
    if (!key || key.length === 0) {
      return hash;
    }
    // eslint-disable-next-line no-plusplus
    for (i = 0; i < key.length; i++) {
      chr = key.charCodeAt(i);
      // eslint-disable-next-line no-bitwise
      hash = (hash << 5) - hash + chr;
      // eslint-disable-next-line
      hash &= hash;
    }
    hash = Math.abs(hash);
    hash = hash.toString(36);
    return hash;
  }

  /**
   *
   * Constructs an adzone string from metadata to be passed to the ad component
   */
  constructAdZone(companyID, siteZone, zone, adzoneOverride, site, name) {
    let finalizedAdZone = zone.replace(/_&/g, '');

    // Override the adzone param if it's passed
    if (adzoneOverride && adzoneOverride !== '') {
      const adzoneOverrideSplit = adzoneOverride.split('/');

      if (get(adzoneOverrideSplit, '[1]')) {
        finalizedAdZone = `${get(
          adzoneOverrideSplit,
          '[0]',
          adzoneOverride
        )}/${get(adzoneOverrideSplit, '[1]', adzoneOverride)}`;
      } else if (adzoneOverride.includes('test-')) {
        finalizedAdZone = adzoneOverride;
      } else {
        finalizedAdZone = `${adzoneOverride}/${adzoneOverride}`;
      }
    }

    // if (adzoneOverride === 'testbid') {
    //   this.adZone = `/19968336/header-bid-tag-${this.state.randNum}`;
    //   return;
    // }

    // finalizedAdZone = 'qa/qa';

    this.adZone = `/${companyID}/${siteZone}/${finalizedAdZone}/${name}`;
  }

  /**
   *
   * Constructs key value pair for ad targetting, returns an key value paired object
   * c_type = content type (slideshow, article, video, homepage, category, tag, etc)
     cms = unique hash of current page url, query string unaffected
     vport = viewport
     cat = category
     tag = tags
     aut = author
     scroll = page number
     adslot = name of the ad unit
     vport = user vport size (large, medium small)
     pos = atf (above the fold) / btf (below the fold)
     video = boolean, is the post a video post (NOT IMPLEMENTED)
     login = is the VISITOR logged in (NOT IMPLEMENTED)
   */
  constructKeyVals(model, pageNum = 0, zone, readTime) {
    const pageLevelKeyvals = {};
    const { id, name, kind, topic, type, url } = model;
    let { tags } = model;
    const abGroupCookie = Cookies.get('abgroup');
    const author = get(model, 'author', '');

    // on post pages, append the slug of post into tags for adcall blacklisting
    if (type === 'post') {
      const urlParts = url.split('/').pop();
      if (urlParts && urlParts.includes('-')) {
        tags = [...tags, ...urlParts.split('-')];
      }
    }

    // if (document.referrer !== '') {
    //   // const trimmedRef = document.referrer
    //   //   .split('')
    //   //   .splice(12, document.referrer.length)
    //   //   .join('');
    //   // // eslint-disable-next-line no-useless-escape
    //   // const reg = /[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
    //   // const match = trimmedRef.match(reg)[0];
    //   // const finalReferrer = decodeURIComponent(match);
    //   pageLevelKeyvals.referrer = decodeURIComponent(document.referrer);
    // } else {
    //   pageLevelKeyvals.referrer = 'none';
    // }
    pageLevelKeyvals.c_type = kind || type;
    pageLevelKeyvals.cms = this.constructCMSHash(url);
    pageLevelKeyvals.cat = topic || name || '';

    if (tags && tags.length) {
      pageLevelKeyvals.tags = union(tags);
    } else {
      pageLevelKeyvals.tags = [name];
    }

    pageLevelKeyvals.aut = author ? author.toLowerCase().replace(/-/g, '') : '';
    pageLevelKeyvals.pos = this.pos;
    pageLevelKeyvals.adslot = this.name;
    pageLevelKeyvals.scroll = String(pageNum); // this needs to be converted to a string

    // CID value for bot activity tracking as per Adops request
    pageLevelKeyvals.CID = getQueryParameterByName('cid') || '0';

    pageLevelKeyvals.chn = [];
    if (topic) {
      pageLevelKeyvals.chn.push(topic);
    }

    if (readTime) {
      const readTimeSplit = readTime.split(' ')[0];
      const readTimeSanitized = isNumber(readTimeSplit)
        ? Number(readTimeSplit)
        : readTimeSplit;
      pageLevelKeyvals.artLength = readTimeSanitized;
    } else {
      pageLevelKeyvals.artLength = 'NA';
    }

    if (id) {
      pageLevelKeyvals.articleid = id;
    }

    if (abGroupCookie) {
      pageLevelKeyvals.abgroup =
        getQueryParameterByName('abgroup') || abGroupCookie;

      // ab group from 11-20  will make requests to client prebid server setup
      // if (parseInt(abGroupCookie, 10) >= 11) {
      // pageLevelKeyvals.prebid_trigger = 'true';
      // alert('prebid trigger set!')
      // }
    }

    pageLevelKeyvals.prebid_trigger = 'true';

    if (window && window.innerWidth) {
      const userWidth = window.innerWidth;
      let vPort;
      if (userWidth >= 1024) {
        vPort = 'l';
      } else if (userWidth < 1024 && userWidth >= 640) {
        vPort = 'm';
      } else if (userWidth < 640) {
        this.userViewport = 'mobile';
        vPort = 's';
      }
      pageLevelKeyvals.vport = vPort;
    }

    pageLevelKeyvals.slotid = `${zone}${pageNum}`;

    if (!Cookies.get('dailycookie')) {
      pageLevelKeyvals.firstimp = 'true';
      try {
        window.localStorage.needToSetDailyCookie = true;
      } catch (e) {
        log.error('Cannot set item in localstorage');
      }
    }

    //  console.log("pageLevelKeyvals ", pageLevelKeyvals);
    this.slotLevelKeyvals = pageLevelKeyvals;

    if (!window.fc_ads) {
      // Set keyval to a global obj to help Browsi
      window.fc_ads = {
        keyVals: {},
        native: {}
      };
    }

    window.fc_ads.keyVals = pageLevelKeyvals;
  }

  /**
   *
   * Constructs a class string BEM style with region be the modifier
   */
  constructAdClass(adName, region, ceros) {
    let classNameFull = `ad-wrapper ad-wrapper--${adName}`;

    if (region && region !== '') {
      classNameFull += ` ad-wrapper--${region}`;
    }

    if (ceros) {
      classNameFull += ` ad-wrapper--ceros`;
    }
    return classNameFull;
  }

  callNativeAlwaysOn(impression) {
    // console.log('slot render ended: callNativeAlwaysOn', impression);
    let responseObj;
    // let dfpCallbackFailed = false

    // 1.
    if (impression.slot.getHtml().indexOf('WAYSON') !== -1) {
      responseObj = get(window.fc_ads, `native['AlwaysOn']`, undefined);
      // console.log('we have a AlwaysOn unit', responseObj);
    }
    // 2.
    if (impression.slot.o !== undefined) {
      if (impression.slot.o._html_.indexOf('WAYSON') !== -1) {
        responseObj = get(window.fc_ads, `native['AlwaysOn']`, undefined);
        // console.log('we have a AlwaysOn unit', responseObj);
      }
    }
    // 3.
    if (impression.slot.j !== undefined) {
      if (impression.slot.j._html_.indexOf('WAYSON') !== -1) {
        responseObj = get(window.fc_ads, `native['AlwaysOn']`, undefined);
        // console.log('we have a AlwaysOn unit', responseObj);
      }
    }

    if (this.props.callback !== undefined && responseObj !== undefined) {
      this.props.callback(responseObj);
    }
  }

  prebidSetup(adUnitName) {
    const userViewportWidth = window.innerWidth;

    // Some units you do not need to call prebid for, add them here
    if (
      adUnitName.indexOf('native') !== -1 ||
      adUnitName.indexOf('welcome') !== -1 ||
      adUnitName.indexOf('oop') !== -1 ||
      adUnitName.indexOf('flexiblelogo') !== -1 ||
      adUnitName.indexOf('sponsorlogo') !== -1 ||
      adUnitName.indexOf('slideshowleaderboard') !== -1 ||
      adUnitName.indexOf('flexibleinterrupter') !== -1 ||
      adUnitName.indexOf('mobile_video_insertion_test') !== -1 ||
      adUnitName.indexOf('flexiblehalfpage_1_sidebarVideo') !== -1
    ) {
      prebidConfProcessed = null;
      return;
    }

    prebidConfProcessed = {
      timeout: prebidConf.timeout,
      floorPrices: prebidConf.floorPrices,
      analytics: prebidConf.analytics,
      useSecondaryAdSizeForPrebid: prebidConf.useSecondaryAdSizeForPrebid,
      priceBuckets: prebidConf.priceBuckets,
      oopBidParams: prebidConf.oopBidParams,
      bidParams: [] // we go through each ad and set bid params specific to each one below
    };

    // check viewport width for prebid bidparams
    if (canUseDOM) {
      // eslint-disable-next-line prefer-const
      let chance = Math.floor(Math.random() * 2) + 1;

      if (userViewportWidth < 1024) {
        // MOBILE BID PARAMS:
        if (
          adUnitName.indexOf('mobile_adhesive') !== -1 ||
          adUnitName.indexOf('mobileadhesive') !== -1
        ) {
          prebidConfProcessed.bidParams = prebidConf.mobile_bidParams320x50;
          // console.log('✅ PREBID MOBILE 320x50', adUnitName, prebidConfProcessed.bidParams, prebidConfProcessed );
          return;
        }

        if (adUnitName.indexOf('mobileleaderboard') !== -1) {
          chance === 1
            ? (prebidConfProcessed.bidParams =
                prebidConf.mobile_bidParams300x250)
            : (prebidConfProcessed.bidParams =
                prebidConf.mobile_bidParams320x50);
          // console.log('✅ PREBID MOBILE mobileleaderboard', adUnitName, prebidConfProcessed.bidParams, prebidConfProcessed);
          return;
        }

        // SET GENERIC MOBILE PREBID CONF  BID PARAMS IF NO MATCHES ARE FOUND ABOVE
        prebidConfProcessed.bidParams = prebidConf.mobile_bidParams300x250;
        // console.log( '✅ PREBID MOBILE 300x250', adUnitName, prebidConfProcessed.bidParams, prebidConfProcessed);
      } else {
        // DESKTOP BID PARAMS:

        // SET BID PARAMS FOR 970x250 / 728x90:
        if (
          adUnitName.indexOf('flexiblebillboard') !== -1 ||
          adUnitName.indexOf('flexiblepushdown') !== -1 ||
          adUnitName.indexOf('flexibleleaderboard') !== -1
        ) {
          chance === 1
            ? (prebidConfProcessed.bidParams = prebidConf.bidParams_970x250)
            : (prebidConfProcessed.bidParams = prebidConf.bidParams_728x90);
          // console.log( '✅ PREBID DESKTOP 970x250', adUnitName, prebidConfProcessed.bidParams, prebidConfProcessed);
          return;
        }

        // SET BID PARAMS FOR 728x90:
        if (
          adUnitName.indexOf('heroFixedleaderboard') !== -1 ||
          adUnitName.indexOf('btwnBillboard') !== -1
        ) {
          prebidConfProcessed.bidParams = prebidConf.bidParams_728x90;
          // console.log( '✅ PREBID DESKTOP 728x90', adUnitName, prebidConfProcessed.bidParams, prebidConfProcessed);
          return;
        }

        // SET BID PARAMS FOR DESKTOP 300x250:
        if (
          adUnitName.indexOf('fixedrectangle') !== -1 ||
          adUnitName.indexOf('slideshowrectangle') !== -1
        ) {
          prebidConfProcessed.bidParams = prebidConf.desktop_bidParams300x250;
          // console.log( '✅ PREBID DESKTOP 300x250', adUnitName, prebidConfProcessed.bidParams, prebidConfProcessed);
          return;
        }

        // SET BID PARAMS FOR DESKTOP 300x250 / 300x600
        if (
          adUnitName.indexOf('flexiblehalfpage') !== -1 ||
          adUnitName.indexOf('flexibleportrait') !== -1
        ) {
          chance === 1
            ? (prebidConfProcessed.bidParams =
                prebidConf.desktop_bidParams300x250)
            : (prebidConfProcessed.bidParams = prebidConf.bidParams_300x600);
          // console.log('✅ PREBID DESKTOP 300x250',adUnitName,prebidConfProcessed.bidParams,prebidConfProcessed);
          return;
        }

        // SET BID PARAMS FOR 300x600/300x250:
        if (adUnitName.indexOf('topFlexRectangle') !== -1) {
          chance === 1
            ? (prebidConfProcessed.bidParams = prebidConf.bidParams_300x600)
            : (prebidConfProcessed.bidParams =
                prebidConf.desktop_bidParams300x250);
          // console.log('✅ PREBID DESKTOP 300x600, chance:',adUnitName,prebidConfProcessed.bidParams,prebidConfProcessed);
          return;
        }

        // SET BID PARAMS FOR GENERIC DESKTOP:
        prebidConfProcessed.bidParams = prebidConf.desktop_bidParams;
        // console.log( 'prebid desktop bid params ✅', adUnitName, prebidConfProcessed.bidParams, prebidConfProcessed);
      }
    }
  }

  render() {
    if (!this.props.initialPageLoad) {
      // If there's a ?adfree=1 then don't render any ad
      const queryAdFree = getQueryParameterByName('adfree');
      if (queryAdFree) {
        return null;
      }

      // only render native_infinitescroll on first article
      if (
        this.props.pageNum > 0 &&
        this.props.name === 'native_infinitescroll'
      ) {
        return null;
      }

      // This here will determine whether to make the actual call or not on mobile
      const userViewportWidth = window.innerWidth;
      const adUnitName = get(this.props, 'name');
      if (adUnitName !== -1 && !this.props.forceAdRender) {
        // console.log('adUnitName', adUnitName);
        // do not show an ads when:
        // mobile ad unit name is not found and viewport > 1024
        if (
          (adUnitName.indexOf('mobile') !== -1 && userViewportWidth >= 1024) ||
          (adUnitName.indexOf('mobile') === -1 && userViewportWidth < 1024)
        ) {
          if (adUnitName.includes('mid_article_inject')) {
            return null;
          }

          if (
            !adUnitName.includes('native') &&
            !adUnitName.includes('test') &&
            !adUnitName.includes('oop')
          ) {
            return null;
          }
        }
        // call prebid setup for ad unit which generates the conf file specific to adunit.
        this.prebidSetup(adUnitName);
      }

      // console.log('render prebidConf adunit', adUnitName, prebidConfProcessed);

      this.constructData();
      this.attachSafeFrameRefreshEvent();
      this.setGDPR();
      const viewableThreshold = 0;
      const renderWhenViewable = this.noLazyLoad === undefined;
      const collapseEmptyDiv =
        typeof get(this.props, 'collapseEmptyDiv') !== 'undefined'
          ? get(this.props, 'collapseEmptyDiv')
          : false;
      const viewableThresholdOverride = this.props.viewableThreshold;

      const viewableThresholdValues = {
        userViewport: this.userViewport ? this.userViewport : 'desktop',
        mobileValue:
          typeof get(viewableThresholdOverride, 'mobile') !== 'undefined'
            ? get(viewableThresholdOverride, 'mobile')
            : 350,
        desktopValue:
          typeof get(viewableThresholdOverride, 'desktop') !== 'undefined'
            ? get(viewableThresholdOverride, 'desktop')
            : 500
      };

      const adUnitClass = this.props.noBorder
        ? 'ad_unit'
        : 'ad-unit ad-unit__border';

      return (
        <div
          className={this.constructAdClass(this.name, this.region, this.ceros)}
        >
          <div className={`ad-wrapper--ad-unit-wrap ${this.region}`}>
            {this.adLabel}
            <div className={adUnitClass}>
              <GPT
                adUnitPath={this.adZone}
                sizeMapping={this.sizeMapping}
                prebidConf={prebidConfProcessed}
                targeting={this.slotLevelKeyvals}
                viewableThreshold={viewableThreshold}
                renderWhenViewable={renderWhenViewable}
                collapseEmptyDiv={collapseEmptyDiv}
                outOfPage={this.oop}
                onSlotRenderEnded={event => {
                  // console.log('slot render ended', this.adZone);
                  if (this.adZone.indexOf('native_mid_article_inject') !== -1) {
                    this.callNativeAlwaysOn(event);
                  }
                  if (this.props.canRefresh) {
                    this.addSlideShowAdRefreshListener(event);
                  }
                  if (get(this.props, 'refreshFunction')) {
                    if (!this.refreshFunctionCalled) {
                      this.props.refreshFunction(event, GPT);
                    }
                    this.refreshFunctionCalled = true;
                  }
                  this.props.dispatchAdLoadedEvent(this.name, true);
                  if (this.props.onSlotRenderEnded) {
                    this.props.onSlotRenderEnded(event);
                  }
                }}
                viewableThresholdValues={viewableThresholdValues}
              />
            </div>
          </div>
        </div>
      );
    }
    return (
      <div
        className={this.constructAdClass(
          this.props.name,
          this.props.region,
          this.props.ceros
        )}
      >
        <div className="ad-wrapper--ad-unit-wrap">
          {this.props.slug === 'false' || this.props.name === 'oop' ? (
            ''
          ) : (
            <div className="ad-wrapper__ad-slug">advertisement</div>
          )}
          <div className="ad-unit ad-unit__border" />
        </div>
      </div>
    );
  }
}

Ad.propTypes = {
  initialPageLoad: PropTypes.bool.isRequired,
  dispatchAdLoadedEvent: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  baseConfig: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  definitions: PropTypes.object.isRequired,
  adzoneOverride: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  model: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  region: PropTypes.string,
  callback: PropTypes.func,
  refreshFunction: PropTypes.func,
  slug: PropTypes.bool,
  oop: PropTypes.bool,
  pos: PropTypes.string,
  pageNum: PropTypes.number,
  noLazyLoad: PropTypes.bool,
  noBorder: PropTypes.bool,
  canRefresh: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  viewableThreshold: PropTypes.object,
  readTime: PropTypes.string,
  onSlotRenderEnded: PropTypes.func,
  ceros: PropTypes.bool,
  forceAdRender: PropTypes.bool
};

Ad.defaultProps = {
  adzoneOverride: '', // Override an adzone
  region: '', // Specify a region
  slug: true, // Display the "advertisement" text or not
  oop: false, // Is this an Out-Of-Page unit?
  pos: 'btf', // Below the Fold or Above the Fold
  pageNum: 1, // For infinite scroll, what page we're on
  noLazyLoad: false,
  callback: null,
  refreshFunction: null,
  noBorder: false, // Display the border for the ad or not, good for when ad is loading
  canRefresh: false, // Whether this unit is eligible for refresh
  viewableThreshold: null, // Override viewable threshold params
  readTime: null, // Article reading time as a keyval
  onSlotRenderEnded: null,
  ceros: false,
  forceAdRender: false
};

function mapDispatchToProps(dispatch) {
  return {
    dispatchAdLoadedEvent(adName, status) {
      return dispatch(adLoaded(adName, status));
    }
  };
}

function mapStateToProps(state) {
  const { initialPageLoad } = state.config;

  return {
    initialPageLoad,
    adsLoaded: get(state, 'ads.data')
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Ad);
